/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object';
import { GetCategoriesRequestParams, GetCategoriesResponse } from './category.types';

export default (
  $axios: any,
): {
  getCategories(params: GetCategoriesRequestParams): Promise<GetCategoriesResponse>;
  index(data?: any): Promise<any>;
} => ({
  async getCategories(params: GetCategoriesRequestParams): Promise<GetCategoriesResponse> {
    return camelize(await $axios.get(`/category`, snakelize({ params })));
  },
  /**
   * 가이드 목록
   * @deprecated 예정
   **/
  async index(data?: any) {
    return camelize(await $axios.get(`/category`, snakelize({ params: data })));
  },
});
